module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-bg-light-blue-inot tw-bg-cards-texture tw-rounded tw-p-3 noselect tw-relative tw-flex tw-flex-col tw-h-[350px]",
    attrs: {
      "data-testid": "notesCard-card",
      "data-cy": "cy-card-activity"
    }
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-mb-3"
  }, [_c('div', {
    staticClass: "tw-mr-auto tw-flex"
  }, [_c('div', {
    staticClass: "tw-font-light tw-text-3xl tw-text-white tw-h-8",
    attrs: {
      "data-testid": "notesCard-title"
    }
  }, [_vm._v("\n                NOTES\n            ")]), _vm._v(" "), (_vm.dataReady && _vm.activites.length > 0) ? _c('div', {
    staticClass: "tw-text-xs tw-bg-white/50 tw-text-black tw-px-2 tw-py-1 tw-rounded tw-uppercase tw-font-bold tw-h-[26px] tw-ml-2"
  }, [_vm._v("\n                " + _vm._s(_vm.activites.length) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('checkbox', {
    staticClass: "tw-mr-3",
    attrs: {
      "label": "Notes cachées",
      "title": "Voir les notes non visibles",
      "dark": true,
      "modeClick": true,
      "disabled": !_vm.dataReady,
      "data-testid": "notesCard-showHiddenNotes-checkbox"
    },
    on: {
      "click": function($event) {
        _vm.showAll()
      }
    }
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "icon": "fa-solid fa-plus",
      "color": "green",
      "title": "Ajouter une note",
      "disabled": !_vm.dataReady,
      "data-testid": "notesCard-addNote-button"
    },
    on: {
      "click": function($event) {
        _vm.addActivity()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-grow tw-overflow-hidden"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "tw-h-full"
  }, [(_vm.activites.length > 0) ? _c('VerticalScroll', [_c('div', {
    staticClass: "tw-w-full tw-divide-y tw-divide-gray-200/75"
  }, _vm._l((_vm.activites), function(activite) {
    return _c('div', {
      staticClass: "tw-flex tw-items-center tw-justify-between tw-py-3",
      class: _vm.activites.length > 1 ? 'first:tw-pt-0 first:tw-pb-3 last:tw-pb-0 last:tw-pt-3' : 'tw-py-0',
      attrs: {
        "data-testid": "notesCard-note"
      }
    }, [_c('div', {
      staticClass: "tw-flex tw-w-full tw-rounded tw-p-3 tw-text-white tw-transition-colors tw-duration-200 tw-cursor-pointer tw-group",
      class: activite.EstImportant ? 'tw-bg-red-500/50 hover:tw-bg-red-500/60' : 'tw-bg-white/10 hover:tw-bg-white/25',
      on: {
        "click": function($event) {
          _vm.viewActivity(activite, false)
        }
      }
    }, [_c('div', {
      staticClass: "tw-w-[calc(100%-80px)]"
    }, [(activite.Date || activite.DateFin) ? _c('div', {
      staticClass: "tw-flex tw-mb-2"
    }, [(activite.Date) ? _c('div', {
      staticClass: "tw-text-xs tw-bg-white/50 tw-px-2 tw-py-1 tw-rounded tw-text-black tw-mr-2"
    }, [_vm._v("\n                                        À partir du :\n                                        "), _c('span', {
      staticClass: "tw-font-bold"
    }, [_vm._v(_vm._s(_vm._f("moment")(activite.Date, "DD/MM/YY")))])]) : _vm._e(), _vm._v(" "), (activite.DateFin) ? _c('div', {
      staticClass: "tw-text-xs tw-bg-white/50 tw-px-2 tw-py-1 tw-rounded tw-text-black"
    }, [_vm._v("\n                                        Jusqu'au :\n                                        "), _c('span', {
      staticClass: "tw-font-bold"
    }, [_vm._v(_vm._s(_vm._f("moment")(activite.DateFin, "DD/MM/YY")))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tw-uppercase tw-leading-5 tw-font-bold",
      attrs: {
        "data-testid": "notesCard-note-title"
      }
    }, [_vm._v(_vm._s(activite.Titre))]), _vm._v(" "), _c('div', {
      staticClass: "tw-leading-5",
      class: {
        'ellipsis': activite.EstApercu
      },
      attrs: {
        "data-testid": "notesCard-note-details"
      }
    }, [_vm._v(_vm._s(activite.Details))])]), _vm._v(" "), _c('div', {
      staticClass: "tw-flex tw-opacity-0 group-hover:tw-opacity-100 tw-items-center tw-transition-opacity tw-duration-200"
    }, [_c('Button', {
      staticClass: "tw-ml-2",
      attrs: {
        "icon": "fa-solid fa-pencil",
        "circle": true,
        "color": "orange",
        "title": "Éditer cette note",
        "data-testid": "notesCard-note-edit-button"
      },
      on: {
        "click": function($event) {
          _vm.viewActivity(activite, true)
        }
      }
    }), _vm._v(" "), _c('Button', {
      staticClass: "tw-ml-2",
      attrs: {
        "icon": "fa-solid fa-trash-can",
        "circle": true,
        "color": "red",
        "title": "Supprimer cette note",
        "data-testid": "notesCard-note-delete-button"
      },
      on: {
        "click": function($event) {
          _vm.deleteActivity(activite)
        }
      }
    })], 1)])])
  }))]) : _c('div', {
    staticClass: "tw-full tw-flex tw-flex-col tw-justify-center tw-items-center"
  }, [_c('div', {
    staticClass: "fa-stack fa-2x tw-mb-2"
  }, [_c('span', {
    staticClass: "fa-solid fa-circle fa-stack-2x tw-text-white/10"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa-light fa-empty-set fa-stack-1x fa-inverse tw-text-white"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tw-text-white"
  }, [_vm._v("Aucune note")])])], 1) : _c('div', {
    staticClass: "tw-w-full tw-divide-y tw-divide-gray-200 tw-animate-pulse tw-overflow-hidden"
  }, _vm._l((3), function(n) {
    return _c('div', {
      staticClass: "tw-py-3 first:tw-pt-0 first:tw-pb-3 last:tw-pb-0 last:tw-pt-3 tw-divide-gray-200"
    }, [_c('div', {
      staticClass: "tw-bg-gray-200 tw-h-[77px] tw-w-full tw-rounded"
    })])
  }))]), _vm._v(" "), _c('modal-card-activity', {
    ref: "modalCardActivity",
    on: {
      "updated": _vm.refresh
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b95af670"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/cards/cardActivity/cardActivity.vue.html
// module id = FELz
// module chunks = 2